export default __webpack_public_path__ + "static/media/collider-failure.e1bb2e47.png";